import Steps from './steps';
export default Steps;
